export default __webpack_public_path__ + "static/media/Instagram-02.885a6d1f.svg";